export const OUTBOUND_OFFSET_DAYS = 7;
export const INBOUND_OFFSET_DAYS = 7;

export const formatDateForInput = (date) => date.toISOString().substring(0, 10);

export const getInitialDates = () => {
  const today = new Date();
  const oneYearLater = new Date(today);
  oneYearLater.setFullYear(today.getFullYear() + 1);

  const outbound = new Date();
  outbound.setDate(outbound.getDate() + OUTBOUND_OFFSET_DAYS);
  const inbound = new Date(outbound);
  inbound.setDate(inbound.getDate() + INBOUND_OFFSET_DAYS);

  return {
    today: formatDateForInput(today),
    oneYearLater: formatDateForInput(oneYearLater),
    outbound: formatDateForInput(outbound),
    inbound: formatDateForInput(inbound),
  };
};
